import React, { createContext, useState, useEffect, useContext } from 'react';

const RefetchContext = createContext(null);
function RefetchProvider({ children, contextRefetch }) {
    const [refetch, setRefetch] = useState(contextRefetch || 0);
    const [context, setContext] = useState(null);
    const setRefetchWithContext = (context) => {
        setRefetch((fetch) => fetch + 1);
        context && setContext(context);
    };
    useEffect(() => {
        contextRefetch && setRefetch((fetch) => fetch + 1);
    }, [contextRefetch]);
    return (React.createElement(RefetchContext.Provider, { value: { refetch, context, setRefetch: setRefetchWithContext } }, children));
}
function useRefetch() {
    return useContext(RefetchContext);
}

export { RefetchProvider, useRefetch };
